import * as React from 'react';

type Options = {
  enabled: boolean;
  exception?: HTMLElement;
};

export const useOnClickOutside = (
  cb: () => void,
  { enabled, exception }: Options
) => {
  const ref = React.useRef<HTMLDivElement>();

  const cbRef = React.useRef<typeof cb>(cb);

  React.useEffect(() => {
    cbRef.current = cb;
  });

  React.useEffect(() => {
    if (enabled) {
      const closePopup = (event: MouseEvent) => {
        if (
          !ref.current?.contains(event.target as HTMLElement) &&
          !exception?.contains(event.target as HTMLElement)
        ) {
          cbRef.current();
        }
      };
      document.addEventListener('click', closePopup, { capture: true });
      return () => {
        document.removeEventListener('click', closePopup, { capture: true });
      };
    }
  }, [enabled, exception]);

  return ref;
};
